var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningLineBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "system/warning_line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning_line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 3.99967C8.36786 3.99967 8.66634 4.29815 8.66634 4.66634V8.66634C8.66634 9.03453 8.36786 9.33301 7.99967 9.33301C7.63148 9.33301 7.33301 9.03453 7.33301 8.66634V4.66634C7.33301 4.29815 7.63148 3.99967 7.99967 3.99967Z",
    fill: "#355DEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 11.333C8.36786 11.333 8.66634 11.0345 8.66634 10.6663C8.66634 10.2982 8.36786 9.99967 7.99967 9.99967C7.63148 9.99967 7.33301 10.2982 7.33301 10.6663C7.33301 11.0345 7.63148 11.333 7.99967 11.333Z",
    fill: "#355DEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33301 7.99967C1.33301 4.31778 4.31778 1.33301 7.99967 1.33301C11.6816 1.33301 14.6663 4.31778 14.6663 7.99967C14.6663 11.6816 11.6816 14.6663 7.99967 14.6663C4.31778 14.6663 1.33301 11.6816 1.33301 7.99967ZM7.99967 2.66634C5.05416 2.66634 2.66634 5.05416 2.66634 7.99967C2.66634 10.9452 5.05416 13.333 7.99967 13.333C10.9452 13.333 13.333 10.9452 13.333 7.99967C13.333 5.05416 10.9452 2.66634 7.99967 2.66634Z",
    fill: "#355DEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningLineBlue);
export default __webpack_public_path__ + "static/media/warning_line_blue.cd9ba1c087884271595cb30f68f2c8d5.svg";
export { ForwardRef as ReactComponent };